/* eslint-disable import/prefer-default-export */
export const MACHINES = {
  ADD: 'MACHINES:ADD',
  DELETE: 'MACHINES:DELETE',
  MOVE: 'MACHINES:MOVE',
  SELECT: 'MACHINES:SELECT',
};



/** WEBPACK FOOTER **
 ** ./src/actions/types.js
 **/